import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import { TextField } from '@mui/material';
import React, { useState } from 'react';
import '../../components/app/common.scss';


function CustomPasswordField({ placeholder = '', name, value = undefined, multiline = false, rows = 1, className = 'textfield-input-wrp', onChange = undefined, variant = undefined }) {
    const [inputText, setInputText] = useState(value);
    const handleInputChange = (e) => {
        setInputText(e.target.value);
    }
    const [showPwd, setShowPwd] = useState(false);
    const toggleView = (e) => {
        setShowPwd(!showPwd);
    }

    return (
        <div className='pwd-input-container'>
            <TextField
                name={name}
                className={className}
                placeholder={placeholder}
                multiline={multiline}
                type={showPwd ? 'text' : 'password'}
                variant={variant}
                fullWidth
                required
                value={value ? value : inputText}
                rows={rows}
                InputLabelProps={{ shrink: false }}
                onChange={onChange ? onChange : handleInputChange}
            />
            {!showPwd ? <VisibilityOutlined className="toggle-pwd" onClick={toggleView} />
                : <VisibilityOffOutlined className="toggle-pwd" onClick={toggleView} />}
        </div>
    );
}

export default CustomPasswordField;